<label>Not In City</label>
<app-autocomplete-field
    [controlName]="controlName"
    [config]="autoCompleteFieldOptions"
>
</app-autocomplete-field>